import { FC } from "react"
import React, { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import UsNumberValidate from "../../modules/utility/usNumberValidate"
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const EditSchool: FC = () => {
  const intl = useIntl()
  let history = useHistory();
  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [fileBase64, setFileBase64] = useState('');
  const [schoolInfo, setschoolInfo] = useState<any>([]);
  const [stateData, setStateData] = useState([]);
  const location99 = useLocation();
  const queryParams99 = new URLSearchParams(location99.search);
  const schoolId = queryParams99.get('schoolId');
  const [schoolProfileInfo, setSchoolProfile] = useState<any>('');
  const red = "red";

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function getImage() {
    //var files = document.getElementById('school_logo').files;  
    var files: any = (document.getElementById("school_logo") as HTMLInputElement | null)?.files;
    console.log(files);
    if (files.length > 0) {

      var fname = files[0].name;
      // var fextn = fname.substr(0, fname.lastIndexOf('.'));
      var fextn = fname.split(".").pop();
      // alert(fextn);
      var fileActName = fname.split(".")[0];
      // alert(fileActName);
      setFileName(fileActName);
      setFileExtension(fextn);
      getBase64(files[0]);

      if (fextn != "jpg" && fextn != "jpeg" && fextn != "png") {

        $("#fileError").show();
        return false;
      } else {
        $("#fileError").hide();
      }

    }
  }
  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      var rds: any = reader.result;
      //var base64result = reader.result.split(',')[1];
      var base64result = rds.split(',')[1];
      setFileBase64(base64result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  function handleChangeSchoolProfileDesc(content) {
    setSchoolProfile(content);
  }

  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function adminViewSchool() {
    const requestObject = {
      "schoolId": schoolId
    };
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminViewSchool(requestOptions).then((res) => {
      const myres = JSON.stringify(res);
      console.log(res.name);
      if (res) {
        $('#school_name').val(res.name);
        $('#address_line1').val(res.address);
        $('#address_line2').val(res.address1);
        $('#school_city').val(res.city);
        $('#school_state').val(res.state);
        $("#school_state option[value='" + res.state + "']").attr("selected", "selected");
        $('#postalcode').val(res.zip);
        $('#phone_number').val(res.phone);
        $('#email_id').val(res.email);
        $('#school_type').val(res.schoolTypeId);
        $("#school_type option[value='" + res.schoolTypeId + "']").attr("selected", "selected");

        // console.log(res.data);         
        setschoolInfo(res);
        //lert(res.data.eventTitle)
        //$("#eventTitle").val(res.data.eventTitle);  
      }
    });


  }
  const submitValue = () => {
    var validateEditorTxt = 1;
    if ($('#school_name').val() == '') {
      $("#snameValidMsg").show();
      $(window).scrollTop($('#snameValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#snameValidMsg").hide();
    }
    if ($('#address_line1').val() == '') {
      $("#address1ValidMsg").show();
      $(window).scrollTop($('#address1ValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#address1ValidMsg").hide();
    }
    if ($('#school_city').val() == '') {
      $("#cityValidMsg").show();
      $(window).scrollTop($('#cityValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#cityValidMsg").hide();
    }
    if ($('#school_state').val() == '') {
      $("#state_validmsg").show();
      $(window).scrollTop($('#state_validmsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#state_validmsg").hide();
    }
    if ($('#postalcode').val() == '') {
      $("#postalvalidmsg").show();
      $(window).scrollTop($('#postalvalidmsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#postalvalidmsg").hide();
    }
    if ($('#school_type').val() == '') {
      $("#schooltype_validmsg").show();
      $(window).scrollTop($('#schooltype_validmsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#schooltype_validmsg").hide();
    }
    if ($('#phone_number').val() == '') {
      $('#phonevalidmsg').show();
      $(window).scrollTop($('#phonevalidmsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $('#phonevalidmsg').hide();
    }
    if (schoolProfileInfo == "") {
      $("#schoolProfileValidMsg").show();
      $(window).scrollTop($('#schoolProfileValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#schoolProfileValidMsg").hide();
    }

    /* if((fileExtension != "") && (fileExtension != "jpg" && fileExtension != "jpeg" && fileExtension != "png" )){
       //document.getElementById('logo').reset();
       $("#fileError").show();
       $(window).scrollTop($('#fileError').position().top);
       validateEditorTxt = 0; 
    }else{
       $("#fileError").hide();
    } */

    if (fileExtension != "") {
      if (fileExtension != "jpg" && fileExtension != "jpeg" && fileExtension != "png") {
        //document.getElementById('logo').reset();
        $("#fileError").show();
        $(window).scrollTop($('#fileError').position().top);
        validateEditorTxt = 0;
      } else {
        $("#fileError").hide();
        // requestObject.fileName = fileName;
        //  requestObject.fileExtension = fileExtension;
        // requestObject.pdfByString = fileBase64;
      }
    }

    if (validateEditorTxt == 0) {
      return false;
    }

    var phone_val = $("#phone_number").val();
    const requestObject: any = {
      "schoolId": schoolId,
      "siteId": 2,
      "name": $('#school_name').val(),
      "schoolTypeId": $('#school_type').val(),
      "content": schoolProfileInfo,
      "address": $('#address_line1').val(),
      "address1": $('#address_line2').val(),
      "city": $("#school_city").val(),
      "state": $("#school_state").val(),
      "zip": $('#postalcode').val(),
      "email": $('#email_id').val(),
      "phone": phone_val,
      //"logoName":fileName,
      //"logoExtension":fileExtension,
      //"logoByteString":fileBase64
    }
    console.log(requestObject); //return false;
    console.log(fileExtension);
    if (fileExtension != "") {
      requestObject.logoName = fileName;
      requestObject.logoExtension = fileExtension;
      requestObject.logoByteString = fileBase64;
    }
    console.log(requestObject); //return false;
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminEditSchool(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#editschoolsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editschoolsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/schoollist');
        }, 1000);
      }
      else {
        $("#editschoolfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editschoolfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }
    });

  }
  useEffect(() => {
    adminViewSchool();
    // $('#phone_number').usPhoneFormat();
    ($('#phone_number') as any).usPhoneFormat();
    $(".se-dialog-tabs").hide();
    $("#schoolProfileValidMsg").hide();
    $('#schooltype_validmsg').hide();
    $('#snameValidMsg').hide();
    $('#address1ValidMsg').hide();
    $('#cityValidMsg').hide();
    $('#state_validmsg').hide();
    $('#postalvalidmsg').hide();
    $('#phonevalidmsg').hide();
    $('#fileError').hide();
    $('#editschoolsuccessMessage').hide();
    $('#editschoolfailMessage').hide();
    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);
  }, []);
  type Props = {
    className: string
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'Edit School' })}</PageTitle>

      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">School Name </label>

                </div>
                <input id="school_name" name="school_name" type="text" className="form-control" placeholder="" />
                <div id="snameValidMsg" style={{ color: red }} className="error">School Name is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Address </label>

                </div>
                <input type="text" id="address_line1" name="address_line1" className="form-control" placeholder="" />
                <div id="address1ValidMsg" style={{ color: red }} className="error">Address is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Address 2</label>

                </div>
                <input type="text" id="address_line2" name="address_line2" className="form-control" placeholder="" />

              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">City</label>

                </div>
                <input type="text" id="school_city" name="school_city" className="form-control" placeholder="" />
                <div id="cityValidMsg" style={{ color: red }} className="error">City is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">State</label>

                </div>
                <select className="form-select" id="school_state" name="school_state" aria-label="Select example" >
                  <option value="" >Select State</option>
                  {
                    stateData.map((state, index) => (
                      <option selected value={state.stateName}>{state.stateName}</option>
                    ))
                  }
                </select>
                <div id="state_validmsg" style={{ color: red }} className="error">State is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Zipcode</label>

                </div>
                <input type="text" id="postalcode" name="postalcode" className="form-control" placeholder="" />
                <div id="postalvalidmsg" style={{ color: red }} className="error">Zipcode is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">School Type</label>

                </div>
                <select className="form-select" id="school_type" name="school_type" aria-label="Select example" >
                  <option value=''>Select School Type</option>
                  <option value="1">College/University</option>
                  <option value="2">Higher Education</option>
                  <option value="3">School District</option>
                  <option value="4">Trade School</option>
                  <option value="5">Vocational</option>
                </select>
                <div id="schooltype_validmsg" style={{ color: red }} className="error">School Type is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Phone</label>
                </div>
                <input type="text" id="phone_number" name="phone_number" className="form-control" />
                <div id="phonevalidmsg" style={{ color: red }} className="error">Phone Number is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Email</label>
                </div>
                <input type="text" id="email_id" name="email_id" defaultValue="emailId" className="form-control" disabled placeholder="" />


              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">School Profile</label>

                </div>
                {/*}<h1>this is FCK editor area</h1>*/}

                {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="schoolProfileId"    
                            data = {schoolInfo.content}                    
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setSchoolProfile(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSchoolProfileDesc}
                  setContents={schoolInfo.content}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="schoolProfileValidMsg" style={{ color: red }} className="error">School Profile is required.</div>
                {/* <textarea className="form-control textarea" placeholder="School Profile" id="school_profile" name="school_profile" spellcheck="false" {...register("schoolProfile", {
                          required: "School Profile is required",
                          maxLength: { value: 5000, message: 'Should not allow more than 5000 characters' }
                        })}>{schoolInfo.content}</textarea>
                        <ErrorMessage
                          errors={errors}
                          name="schoolProfile"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-4">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">School Logo</label>
                  <small className="mb-3">JPG, JPEG or PNG, 500px X 500px, .5 MB max size</small>
                </div>
                <img className="w-100 mt-4" src={schoolInfo.logoUrl} alt='' />
                <br />
                <input className="form-control form-control-lg browse mr-2" id="school_logo" type="file" onChange={() => getImage()} />
                {/* <input type="file" id="school_logo" name="school_logo" className="form-control" onChange={upload => setschoollogo()} {...register("schoolLogo", {
                          required: "school Logo is required."
                        })}/>*/}
                <div id="fileError" style={{ color: red }} className="error">Invalid file format</div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="mb-10">

              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "135px" }}> Update School </button>
              </div>
            </div>

            <div id="editschoolsuccessMessage" className="alert alert-success" role="alert">School Updated Successfully</div>
            <div id="editschoolfailMessage" className="alert alert-danger" role="alert">Please try again</div>
          </div>
        </div>
      </form>
    </>
  )
}
export { EditSchool }